import { IMailGroup } from 'app/shared/model/mail-group.model';

export interface IMailType {
  id?: number;
  name?: string;
  price?: number;
  isEnablePop3?: boolean | null;
  isHot?: boolean | null;
  ttl?: string | null;
  location?: string | null;
  mailGroup?: IMailGroup | null;
  note?: string;
  loyaltyPrice?: number | null;
  loyaltyDays?: number | null;
  loyaltyMode?: string | null;
  loyaltyExpireDate?: string | null;
  loyaltyTarget?: string | null;
  loyaltyUsers?: string | null;
}

export const defaultValue: Readonly<IMailType> = {
  isEnablePop3: false,
  isHot: false,
};
